var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"error-message"},[(_vm.icon)?_c('AlertCircle',{staticClass:"icon"}):_vm._e(),_vm._l((_vm.errorMessages),function(error,idx){return _c('p',{key:'error-' + idx,staticClass:"error"},[_vm._v(" "+_vm._s(error)+" ")])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }